/*eslint-disable*/
import React, { useState, useContext, useEffect, useRef } from 'react';
import { STYLES } from "config";

import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

import {
    Button,
    Input as RSInput,
} from "reactstrap";

import moment from 'moment';

import CircularLoading from "../../components/CircularLoading";
import CustomDropDownPicker from '../../components/CustomDropDownPicker';
import CustomImageDragger from '../../components/CustomImageDragger';

import PropertyTypeDropdown from '../../components/PropertyTypeDropdown';


import { useSelector, useDispatch } from "react-redux";
import { FirebaseContext } from "common";
import GoogleMapsAutoComplete from "components/GoogleMapsAutoComplete";

import FlatList from "flatlist-react";

import { useNavigate, useLocation } from "react-router-dom";

import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import reindexImagesAndCaptionsPreserveInPlace from 'components/reindexImagesAndCaptionsPreserveInPlace';

const styles = {
    Card: {
        padding: "12px",
        backgroundColor: "#f9f9f9",
        borderRadius: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.4)",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        gap: "20px",
    },
    CardHeader: {
        marginBottom: "16px",
        borderBottom: "1px solid #eee",
        paddingBottom: "8px",
    },
    CardBody: {
        padding: "8px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "30px",
    },

    disabledField: {
        backgroundColor: '#f5f5f5',
        color: '#b0b0b0',
    },

    Column: {
        padding: "14px",
        marginTop: "8px",
        flex: 1, // evenly distribute columns
        display: "flex",
        flexDirection: "column",
    },

    text: {
        color: "grey",
    },

    inputStyle: {
        borderWidth: 1,
        borderColor: STYLES.TERTIARY_APP_CLR,
        height: 24,
        backgroundColor: "white",
        fontSize: 16,
        borderRadius: 4,
        color: "grey",

    },
    Row: { display: "flex", flexDirection: "row", gap: "15px", gridTemplateColumns: "1fr 1fr", },
    CheckboxWrapper: {
        //display: "flex",
        alignItems: "center",
        width: "100%",
        flexDirection: "row",
        gap: "8px",
        padding: " 6px",
        border: "2px solid #ccc",
        borderRadius: "4px",
        background: "#fafafa",
    },
    DropdownWrapper: {
        width: "100%",
        position: "relative",
        //zIndex: 2"" // keeps dropdown above neighbors
    },
    MinimizeBtn: {
        border: "none",
        background: "transparent",
        fontSize: "18px",
        cursor: "pointer",
        color: "#666",
    },
    card: {
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '16px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
    },
    text: {
        margin: '4px 0',
        fontSize: '16px',
    },
    Divider: { margin: '8px 0', },
    label: {
        fontWeight: 'bold',
        marginRight: '4px',
    },
    scrollableBody: {
        maxHeight: '50vh',
        overflowY: 'auto',
        paddingRight: '12px',
    },

}
const Input = styled(TextField)(({ required }) => ({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'grey',
            borderWidth: 2,
        },
        '&:hover fieldset': {
            borderColor: '#999',
        },
        '&.Mui-focused fieldset': {
            borderLeftWidth: 4,
            padding: '4px !important',
        },
        position: 'relative',
        '&::before': required ? {
            content: '""',
            position: 'absolute',
            left: '6px',
            top: '50%',
            transform: 'translateY(-50%)',
            height: '60%',
            width: '3px',
            backgroundColor: '#ff0000',
            borderRadius: '1px',
            zIndex: 1,
        } : {},
    },
    '& input': {
        color: 'grey',
        paddingLeft: required ? '16px' : '14px',
    },
}));


function CreateListing() {

    //Reducer 
    const auth = useSelector((state) => state.auth);
    const brokers = useSelector((state) => state.brokers.users);
    const listingManagementReducer = useSelector((state) => state.ListingData);
    const landlordManagementReducer = useSelector((state) => state.landlorddata);
    const aiMarketingReducer = useSelector((state) => state.aidata);
    const areaData = useSelector((state) => state.areaData);
    const branchManagementReducer = useSelector((state) => state.branchData);

    console.log('areaData', areaData)

    //Actions
    const { api } = useContext(FirebaseContext);
    const { CreateListing, clearListingErrors, GenerateListingDescription, clearAiReducer } =
        api;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fileInputRef = useRef(null);

    //usestates 
    const [onMarketSince, setOnMarketSince] = useState("");
    const [areaList, setAreaList] = useState([]);
    const [mandateStartDate, setMandateStartDate] = useState("");
    const [mandateEndDate, setMandateEndDate] = useState("");
    const [collapsed, setCollapsed] = useState(false);
    const [currentBranch, setCurrentBranch] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    const [image, setImage] = useState([]);
    const [captions, setCaptions] = useState({});
    const [brokerList, setBrokerList] = useState([]);
    const [validImages, setValidImages] = useState([]);
    const [state, setstate] = useState({
        availabilityOption: "",
        status: "Active",
        municipalValue: "",
        buildingGrade: "",
        valuationPrice: "",
        gla: "",
        address: "",
        standSize: "",
        type: "",
        poaMessage: "Price on Application",
        erf: "",
        deposit: "",
        location: "",
        // title: "",
        postalAddress: "",
        Street: "",
        typeOfProperty: false,
        typeOfMandate: "",
        typeOfTitle: "",
        unit: "",
        monthlyLevy: "",
        // complexName: "",    
        monthlyLevyPerSQM: "",
        showLocation: false,
        heightOfEaves: 0,
        specialLevy: "",
        floorLoading: "",
        truckAccess: "",
        yardAccess: "",
        parkingType: "",
        locationType: "",
        threePhasePower: false,
        buildingGrades: "",
        powerAmps: "",
        heightForRacking: "",
        heightToEaves: "",
        sprinklered: false,
        rollerShutterDoors: "",
        heightOfRollerShutterDoors: "",
        studHeight: "",
        dockLevellers: "",
        heightOfDockLevellers: "",
        security: false,
        airConditioning: false,
        multiTenanted: false,
        leaseType: "",
        leasePeriod: "",
        onMarketSince: "",
        availableFrom: "",

        additionalNotes: "",
        bathrooms: 0,
        communalBathrooms: false,
        unisexBathrooms: false,
        executiveBathrooms: false,
        bathroomDescription: "",

        p24propertyType: "",
        price: "",
        openParkingBays: "",
        openParkingCostPerBay: "",
        openParkingTotalCost: "",
        basementParkingBays: "",
        basementParkingCostPerBay: "",
        basementParkingTotalCost: "",
        coveredParkingTotalCost: "",
        coveredParkingBays: "",
        coveredParkingCostPerBay: "",
        saleboth: "",
        poa: false,
        officeSize: "",
        officePrice: "",
        retailSize: "",
        retailPrice: "",
        factorySize: "",
        factoryPrice: "",
        yardSize: "",
        yardPrice: "",
        landSize: "",
        landSizeMeasurement: "sqm",
        floorSize: "",
        Description: "",
        floorNumber: "",
        floorSizeMeasurement: "sqm",
        industrialCommercial: "",
        buildingHieght: "",
        grossmonthlyRental: "",
        ownerBroker: "",
        office: auth.info.profile.adminHomeOffice,
        seller: {
            entityName: "",
            monthlyRates: "",
            registrationNumber: "",
            postalAddress: "",
            ownername: "",
            company: "",
            cellTel: "",
            homeTel: "",
            workTel: "",
            Deposit: "",
            investor: false,
            email: "",
            monthlyLevy: "",
            monthlyLevyPerSQM: "",
            specialLevy: "",
            vatVendor: false,
            vatNumber: "",
        },
    });

    //regjex

    function isOnlyNumbers(value) {
        console.log(`In number check: ${value}`)
        return /^\d+$/.test(value);
    }

    function isCountryCode(value) {
        console.log(`In country code check: ${value}`)
        return /^\+\d{1,4}$/.test(value);
    }

    const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneRegex =
        /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;



    const handleButtonClick = () => {
        fileInputRef.current.click(); // open file selector
    };


    const parseAddressComponents = (components) => {
        const address = {};

        console.log('components', components)

        components.forEach((c) => {
            const types = c.types;

            if (types) {
                if (types.includes("street_number")) {
                    address.streetNumber = c.longText;
                }
                if (types.includes("route")) {
                    address.streetName = c.longText
                        ;
                }
                if (types.includes("subpremise")) {
                    address.unitNumber = c.longText;
                }
                if (types.includes("establishment")) {
                    address.buildingName = c.longText;
                }
                if (types.includes("premise")) {
                    address.complexName = c.longText;
                }
                if (types.includes("locality")) {
                    address.city = c.longText;
                }
                if (types.includes("administrative_area_level_1")) {
                    address.province = c.longText;
                }
                if (types.includes("postal_code")) {
                    address.postalCode = c.longText;
                }
            }

        });

        return address;
    };

    const parseSuburbComponents = (components) => {
        const suburb = {};

        console.log('S_components', components)

        components.forEach((c) => {
            const types = c.types;

            if (types) {
                if (types.includes("sublocality_level_2")) {
                    suburb.suburb = c.longText;
                }
                if (types.includes("locality")) {
                    suburb.city = c.longText;
                }
                if (types.includes("administrative_area_level_1")) {
                    suburb.province = c.longText;
                }
                if (types.includes("postal_code")) {
                    suburb.postalCode = c.longText;
                }
            }

        });

        let suburbStringFormat = `${suburb.suburb}, ${suburb.city}, ${suburb.province}, ${suburb.postalCode}`

        return suburbStringFormat;
    };




    useEffect(() => {
        if (branchManagementReducer.branches) {
            for (
                let index = 0;
                index < branchManagementReducer.branches.length;
                index++
            ) {
                if (
                    branchManagementReducer.branches[index].BranchName ===
                    auth.info.profile.adminHomeOffice
                ) {
                    setCurrentBranch(branchManagementReducer.branches[index]);
                }
            }
        }
    }, []);


    //consts
    const mandateTypes = [
        { value: "Open", label: "Open", },
        { value: "Sole", label: "Sole", },
        { value: "Company Listing", label: "Company Listing", },
        { value: "Shared", label: "Shared", },
        { value: "Referral", label: "Referral", }
    ]

    const usageTypes = [
        { value: "Commercial", label: "Commercial", },
        { value: "Industrial", label: "Industrial", },
    ]

    const leasePeriods = [{ label: "1 month", value: "1" },
    { label: "2 month", value: "2" },
    { label: "3 month", value: "3" },
    { label: "6 month", value: "6" },
    { label: "9 months", value: "9" },
    { label: "12 month", value: "12" },
    { label: "24 month", value: "24" },
    { label: "36 month", value: "36" },
    { label: "48 month", value: "48" },
    { label: "60 month", value: "60" },
    { label: "10 year plus", value: "120" },
    { label: "15 year plus", value: "180" },
    { label: "25 year plus", value: "300" },
    { label: "35 year plus", value: "420" },
    { label: "Negotiable", value: "Negotiable" },];
    const availableFromOptions = [{ label: "Immediately", value: "Immediately" },
    { label: "Negotiable", value: "Negotiable" },
    { label: "Specific Date", value: "Specific Date" },];

    const leaseTypes = [{ label: "Percentage", value: "Percentage" },
    { label: "Net", value: "Net" },
    { label: "Double Net", value: "DoubleNet" },
    { label: "Triple Net", value: "TripleNet" },
    { label: "Fully Serviced Lease Gross", value: "FullyServicedLeaseGross" },]
    const listingTypes = [
        { value: "tolet", label: "To Let" },
        { value: "sale", label: "For Sale" }
    ];
    const buildingGrades = [
        { value: "A", label: "A" },
        { value: "AAA", label: "AAA" },
        { value: "B", label: "B" },
        { value: "C", label: "C" },
        { value: "P", label: "P" }

    ];
    const truckAccessOptions = [
        { value: "Small_Trucks", label: "Small Trucks" },
        { value: "Single_Trailer", label: "Single Trailer" },
        { value: "Interlink", label: "Interlink" },
        { value: "Superlink", label: "Superlink" }


    ];

    const locationOptions = [
        { value: "address", label: "Address" },
        { value: "suburb", label: "Suburb" },
    ];

    const yardAccessOptions = [];
    const parkingTypes = [];


    const titleTypes = [
        { value: "Freehold", label: "Freehold" },
        { value: "Sectional Title", label: "Sectional Title" },
        { value: "None", label: "None" },
        { value: "Share Block", label: "Share Block" }
    ];

    const measurementTypes = [
        { value: "sqm", label: "Square Metres (sqm)" },
        { value: "ha", label: "Hectares (ha)" },
    ];

    const availabilityTypes = [
        { value: "Immediate", label: "Immediate" },
        { value: "Negotiable", label: "Negotiable" },
        { value: "Specific Date", label: "Specific Date" },
    ];


    const handleGenerateDescription = () => {
        // if (!ListingData || !firebase) return;
        //console.log("Description:", description);

        console.log('state', state)


        let ListingData = { ...state, markertingHeading: "", description: "" }

        dispatch(GenerateListingDescription(ListingData));
        console.log("AI Generated Description:", aiMarketingReducer);

    };


    useEffect(() => {

        if (!aiMarketingReducer.loadingDescription && aiMarketingReducer.completed) {
            setstate({
                ...state,
                marketingHeading: aiMarketingReducer.aiGeneratedTitle,
                description: aiMarketingReducer.aiGeneratedDescription
            });
            dispatch(clearAiReducer());
        }


    }, [aiMarketingReducer]);


    useEffect(() => {

        let arr2 = [];

        if (areaData && areaData.areas) {
            for (let index = 0; index < areaData.areas.length; index++) {
                const element = areaData.areas[index];

                // Populate the list with all brokers, remove brokerHomeOffice filter
                if (element.selectedBranchName === auth?.info?.profile?.adminHomeOffice) {
                    console.log(`match`);
                    arr2.push({
                        value: element.areaId,
                        label: element.areaName
                    });
                }
            }
            setAreaList(arr2.sort((a, b) => a.label.localeCompare(b.label)));
            console.log("Area List:", arr2.length > 0 ? arr2 : "No areas found"); // Log area list to verify population
        }

    }, [areaData]);



    //useEffects

    //!!Extremly important useEffect
    //?? Used to tell if the Listing was Created and handle errors from reducers and actions
    //?? Last Updated 2024/03/05
    useEffect(() => {
        if (
            listingManagementReducer.completed &&
            listingManagementReducer.success
        ) {
            alert("Listing Created");
            dispatch(clearListingErrors());
            navigate("/stock", {
                state: "Active",
            });
        }

        if (
            !listingManagementReducer.success &&
            listingManagementReducer.error.flag
        ) {
            console.log(
                "listingManagementReducer.error",
                listingManagementReducer.error.msg
            );
            alert(
                `\tCreate Listing Failed \n ${listingManagementReducer.error.msg}`
            );
            dispatch(clearListingErrors());
        }
    }, [listingManagementReducer]);



    useEffect(() => {
        let arr = [];
        if (brokers) {
            for (let index = 0; index < brokers.length; index++) {
                const element = brokers[index];

                // Populate the list with all brokers, remove brokerHomeOffice filter
                if (element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice) {
                    arr.push({
                        value: element.id, // The broker ID (or name if preferred)
                        label: `${element.firstName} ${element.lastName}`, // Broker name
                    });
                }
            }
            setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
        }
    }, [brokers]);

    useEffect(() => {
        // Default today's date in YYYY-MM-DD format
        const today = new Date().toISOString().split("T")[0];
        setOnMarketSince(today);
        setMandateStartDate(today);
        setMandateEndDate(today);
    }, []);



    useEffect(() => {

        console.log('state', state)

    }, [state])

    //functions 
    const saveData = (location, data) => {
        setstate({
            ...state,
            [location]: data,
        });
    };


    const saveAddressData = (location, data) => {
        console.log('data', data)
        setstate({
            ...state,
            address: { ...state?.address, [location]: data },
        });
    };

    const saveCordsData = (location, data) => {
        console.log('data', data)
        setstate({
            ...state,
            address: { ...state?.address, coords: { ...state.address.coords, [location]: data } },
        });
    };

    const toggleTwo = () => setIsOpen(!isOpen);

    function onImageChange(e) {
        setImage((prev) => [...prev, ...e.target.files]);
        console.log(`files: ${JSON.stringify(e.target.files)}`)
    }

    function removeUndefinedRecords(validImages) {
        return Object.values(validImages).filter((value) => value !== undefined)
            .reduce((acc, value, index) => {
                acc[`Image${String(index).padStart(3, "0")}`] = value;
                return acc;
            }, {});
    }

    function mapImagesToCaptions(images, captions) {
        const result = {};

        images.forEach((image, index) => {
            const key = `Image${String(index).padStart(3, '0')}`;
            result[key] = captions[image.name] || "";
        });

        return result;
    }

    function matchCaptionsToImages(images, captions) {
        const newCaptions = {};

        for (const [imgKey] of Object.entries(images)) {
            // If captions already has the same key, use it
            if (captions[imgKey]) {
                newCaptions[imgKey] = captions[imgKey];
            } else {
                // Otherwise, fall back to the first available caption
                const firstCaptionKey = Object.keys(captions)[0];
                if (firstCaptionKey) {
                    newCaptions[`Image${imgKey}`] = captions[firstCaptionKey];
                    delete captions[firstCaptionKey]; // remove so it's not reused
                } else {
                    newCaptions[`Image${imgKey}`] = ""; // no caption left
                }
            }
        }

        console.log(`new captions: ${JSON.stringify(newCaptions)}`)

        return newCaptions;
    }

    const saveUserData = (location, data) => {
        setstate({
            ...state,
            seller: {
                ...state.seller,
                [location]: data,
            },
        });
    };


    const RenderModal = () => {


        const [filteredLandlords, setfilteredLandlords] = useState([])


        function filterLandlords(text) {

            if (text.length > 0) {
                setfilteredLandlords(landlordManagementReducer.landlords.filter((landlord) => {
                    const search = text.toLowerCase();
                    return (
                        landlord.ownerName?.toLowerCase().includes(search) ||
                        landlord.companyName?.toLowerCase().includes(search) ||
                        landlord.companyRegNumber?.toLowerCase().includes(search) ||
                        landlord.companyEmail?.toLowerCase().includes(search) ||
                        landlord.companyContactNumber?.toLowerCase().includes(search)
                    );
                }));
            } else {
                setfilteredLandlords([]);
            }




        }


        const RenderItem = ({ ownerName, companyName, companyRegNumber, companyEmail, companyContactNumber }) => {
            return (
                <div style={styles.card} onClick={() => {

                    setstate({
                        ...state,
                        seller: {
                            ...state.seller,
                            ownername: ownerName,
                            company: companyName,
                            registrationNumber: companyRegNumber,
                            email: companyEmail,
                            cellTel: companyContactNumber,
                        },
                    })
                    setIsOpen(false);
                }}>
                    <p style={styles.text}><span style={styles.label}>Owner:</span> {ownerName}</p>
                    <p style={styles.text}><span style={styles.label}>Company:</span> {companyName}</p>
                    <p style={styles.text}><span style={styles.label}>Reg. Number:</span> {companyRegNumber}</p>
                    <p style={styles.text}><span style={styles.label}>Email:</span> {companyEmail}</p>
                    <p style={styles.text}><span style={styles.label}>Contact:</span> {companyContactNumber}</p>
                </div>
            );
        };

        return (
            <Modal style={{ cursor: "pointer" }} isOpen={isOpen} toggle={toggleTwo} centered>
                <ModalHeader>Import Owner Details</ModalHeader>
                <ModalBody style={styles.scrollableBody}>
                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            filterLandlords(value.target.value);
                        }}
                        type="text"
                        label="search for a landlord"
                    />
                    <FlatList
                        keyExtractor={(item, index) => index.toString()}
                        list={filteredLandlords.length > 0 ? filteredLandlords : landlordManagementReducer.landlords || []}
                        renderOnScroll
                        renderItem={(item) => <RenderItem {...item} />}
                        renderWhenEmpty={() =>
                            <div>
                                <p>There currently is no Landlord please go and make a new landlord contact!</p>

                                <Button>
                                    <a onClick={() => {
                                        navigate("/manageLandlords");
                                    }} style={{ color: "white" }}>Go to Landlords</a>
                                </Button>
                            </div>}
                    />
                </ModalBody>
                <ModalFooter>
                    {/* Optional footer buttons can go here */}
                </ModalFooter>
            </Modal>
        );
    };


    const isYouTubeVideo = (item) => {
        const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/)([\w\-]+)|youtu\.be\/([\w\-]+))(?:\S+)?$/;;
        return youtubeRegex.test(item);
    };

    return landlordManagementReducer.loading || listingManagementReducer.loading ? (
        <CircularLoading label={"Just a Minute Getting Everything Done For You"} />
    ) : (
        <div style={styles.container}>
            <div style={styles.Card}>
                <div style={styles.CardHeader}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <p className="h4" style={styles.text}>Listing Details</p>
                        <p style={{ fontSize: '0.7rem', color: '#777' }}>
                            Note: Fields marked with ** are recommended by
                            <span style={{ display: 'block' }}> Property24 to improve your listing’s Quality Score.</span>
                        </p>
                    </div>
                </div>

                <div style={styles.CardBody}>

                    <div style={{ ...styles.Row, zIndex: 45 }}>

                        <div style={{ width: "100%" }}>
                            <PropertyTypeDropdown
                                value={state.typeOfProperty}
                                onChange={(selectedProperty, p24Value, ppValue) => {
                                    setstate({
                                        ...state,
                                        typeOfProperty: selectedProperty,
                                        p24propertyType: p24Value,
                                        pppropertyType: ppValue
                                    });
                                }}
                            />
                        </div>

                        <div style={{ width: "100%" }}><CustomDropDownPicker
                            borderColor="grey"
                            required
                            options={usageTypes}
                            isMulti={false}
                            value={state.industrialCommercial}
                            onChange={(e) => saveData("industrialCommercial", e)}
                            placeholder="Select A Usage Type"
                        /></div>

                    </div>



                    <div style={{ ...styles.Row, zIndex: 35 }}>

                        <div style={{ width: "100%" }}><CustomDropDownPicker
                            borderColor="grey"
                            options={listingTypes}
                            isMulti={false}
                            required
                            value={state.type}
                            onChange={(e) => saveData("type", e)}
                            placeholder="Select A Listing Type"
                        /></div>

                        <div style={{ width: "100%", zIndex: 8 }}><CustomDropDownPicker
                            borderColor="grey"
                            options={titleTypes}
                            isMulti={false}
                            value={state.typeOfTitle}
                            onChange={(e) => saveData("typeOfTitle", e)}
                            placeholder="Select A Title Type**"
                        /></div>

                    </div>




                    <div style={styles.Row}><div style={{
                        width: "100%",
                        zIndex: 6
                    }}><CustomDropDownPicker
                            borderColor="grey"
                            options={brokerList}
                            isMulti={false}
                            value={state.ownerBroker}
                            required
                            onChange={(e) => saveData("ownerBroker", e)}
                            placeholder="Select A Broker"
                        /></div></div>

                    <div style={styles.Row}><div style={{
                        width: "100%",
                    }}>
                        <Input
                            multiline
                            variant="outlined"
                            rows={4}
                            fullWidth
                            sx={{
                                '& textarea': {
                                    resize: 'vertical',        // 'vertical' | 'horizontal' | 'both'
                                    overflow: 'auto',
                                },
                            }}
                            onChange={(value) => {
                                value.preventDefault();
                                saveData("additionalNotes", value.target.value);
                            }}
                            type="text"
                            label="Notes"
                        />
                    </div>
                    </div>

                </div>

            </div>


            <div style={styles.Card}>

                <div style={styles.CardHeader}> <p className='h4' style={styles.text}>Address Details</p>  </div>

                <div style={styles.CardBody}>


                    <div style={{ flex: 1 }}>
                        <GoogleMapsAutoComplete
                            onChange={(value) => {
                                console.log("Google place selected", value);

                                // Parse the address components
                                const parsedAddress = parseAddressComponents(value?.addressComponents || []);
                                const suburb = parseSuburbComponents(value?.addressComponents || [])
                                console.log('parsedAddress', parsedAddress);
                                // Update the state
                                setstate({
                                    ...state,
                                    address: {
                                        ...state.address,
                                        description: value?.description || "",
                                        streetNumber: parsedAddress.streetNumber || "",
                                        streetName: parsedAddress.streetName || "",
                                        unitNumber: parsedAddress.unitNumber || "",
                                        complexName: parsedAddress.complexName || "",
                                        buildingName: parsedAddress.buildingName || "",
                                        coords: {
                                            lat: value?.location?.latitude,
                                            lng: value?.location?.longitude,
                                        },
                                        suburb: suburb,
                                    },
                                });
                            }}
                            placeholder="Search Address"
                            value={state.address?.description || ""}
                        />

                    </div>




                    <div style={styles.Row}>

                        <Input
                            value={state.address?.streetNumber || ""}
                            variant="outlined"
                            onChange={(value) => {
                                value.preventDefault();
                                saveAddressData("streetNumber", value.target.value);
                            }}
                            required
                            fullWidth
                            type="text"
                            label="Street Number"
                        />

                        <Input

                            variant="outlined"
                            onChange={(value) => {
                                value.preventDefault();
                                saveAddressData("streetName", value.target.value);
                            }}
                            required
                            fullWidth
                            value={state.address?.streetName || ""}
                            type="text"
                            label="Street Name"
                        />

                    </div>


                    <div style={styles.Row}>

                        <Input

                            variant="outlined"
                            onChange={(value) => {
                                value.preventDefault();
                                saveAddressData("unitNumber", value.target.value);
                            }}
                            fullWidth
                            value={state.address?.unitNumber || ""}
                            type="text"
                            label="Unit Number"
                        />

                        <Input

                            variant="outlined"
                            onChange={(value) => {
                                value.preventDefault();
                                saveAddressData("complexName", value.target.value);
                            }}
                            fullWidth
                            value={state?.address?.complexName || ""}
                            type="text"
                            label="Complex Name"
                        />

                    </div>


                    <div style={styles.Row}>

                        <Input

                            variant="outlined"
                            fullWidth
                            onChange={(value) => {
                                value.preventDefault();
                                saveData("floorNumber", value.target.value);
                            }}
                            type="text"
                            value={state.floorNumber}
                            label="Floor Number"
                        />

                        <Input
                            variant="outlined"
                            onChange={(value) => {
                                value.preventDefault();
                                saveAddressData("buildingName", value.target.value);
                            }}
                            fullWidth
                            value={state.address?.buildingName || ""}
                            type="text"
                            label="building name"
                        />

                    </div>
                    <div style={styles.Row}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "16px",         // spacing between inputs
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            <div style={{ flex: 1 }}>
                                <Input
                                    variant="outlined"
                                    fullWidth
                                    type="number"
                                    value={state.erf || ""}
                                    onChange={(e) => saveData("erf", e.target.value)}
                                    label="Enter ERF Number"
                                />
                            </div>


                        </div>

                    </div>

                    <div style={{ ...styles.Row, zIndex: 20 }}>
                        <div style={styles.DropdownWrapper}>
                            <CustomDropDownPicker
                                options={areaList}
                                isMulti={false}
                                value={state?.selectedArea?.areaId}
                                required
                                placeholder="Location"
                                onChange={(selectedArea) => {
                                    let fullArea = areaData.areas.find(x => x.areaId === selectedArea);

                                    setstate({
                                        ...state,
                                        selectedArea: fullArea,
                                        suburbId: fullArea.p24.suburbId,
                                        cityId: fullArea.p24.cityId,
                                        provinceId: fullArea.p24.provinceId,
                                    })

                                }}
                            />
                        </div>

                    </div>


                    <div style={styles.Row}>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                type="checkbox"
                                checked={state.showLocation || false}
                                onChange={(e) => saveData("showLocation", e.target.checked)}
                            />
                            <span>Show Location On Map</span>
                        </div>
                    </div>


                    <div style={styles.DropdownWrapper}>
                        <CustomDropDownPicker
                            borderColor="grey"
                            options={locationOptions}
                            value={state.locationType}
                            onChange={(value) => saveData("locationType", value)}
                            placeholder="Publish Location As"
                            required
                        />
                    </div>


                </div>
            </div>

            <div style={styles.Card}>
                <div style={styles.CardHeader}>
                    <p className="h4" style={styles.text}>Pricing Details</p>
                </div>
                <div style={styles.CardBody}>
                    {/* POA Checkbox */}
                    <div style={styles.Row}>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                type="checkbox"
                                checked={state.poa || false}
                                onChange={(e) => saveData("poa", e.target.checked)}
                            />
                            <span>POA</span>
                        </div>
                    </div>

                    {/* Show message if no listing type is selected */}
                    {!state.type && (
                        <p className="h6" style={styles.text}>
                            Please select a listing type to see pricing fields
                        </p>
                    )}

                    {/* Show sale fields when listing type is sale or both */}
                    {(state.type === "sale" || state.type === "both") && (
                        <>
                            <div style={styles.Row}>
                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(e) => saveData("deposit", e.target.value)}
                                    type="text"
                                    label="Sale Deposit Price"
                                    value={state.deposit}
                                />

                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(e) => saveData("price", e.target.value)}
                                    type="text"
                                    label="Sale Price"
                                    value={state.price}
                                />
                            </div>

                            <div style={styles.Row}>
                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(e) => saveData("municipalValue", e.target.value)}
                                    type="number"
                                    label="Municipal Value"
                                    value={state.municipalValue}
                                />

                                <Input
                                    variant="outlined"
                                    fullWidth
                                    onChange={(e) => saveData("valuationPrice", e.target.value)}
                                    type="number"
                                    label="Valuation Price"
                                    value={state.valuationPrice}
                                />
                            </div>
                        </>
                    )}

                    {/* Show rental fields when listing type is tolet or both */}
                    {(state.type === "tolet" || state.type === "both") && (
                        <div style={styles.Row}>
                            <Input
                                variant="outlined"
                                fullWidth
                                onChange={(e) => saveData("deposit", e.target.value)}
                                type="text"
                                label="Rent Deposit Price"
                                value={state.deposit}
                            />

                            <Input
                                variant="outlined"
                                fullWidth
                                onChange={(e) => saveData("grossmonthlyRental", e.target.value)}
                                type="text"
                                label="Gross Monthly Rental"
                                value={state.grossmonthlyRental}
                            />
                        </div>
                    )}

                    {/* Show price per square meter when any listing type is selected */}
                    {state.type && (
                        <div style={styles.Row}>
                            <Input
                                variant="outlined"
                                fullWidth
                                onChange={(e) => saveData("ppsm", e.target.value)}
                                type="number"
                                label="Price Per Square Meter"
                                value={state.ppsm}
                            />
                        </div>
                    )}

                    {/* Help text when POA is enabled */}
                    {state.poa && (
                        <p style={{ color: "#666", fontStyle: "italic", marginTop: "-15px" }}>
                            The listing will show "POA" instead of prices on public platforms.
                        </p>
                    )}
                </div>
            </div>

            <div style={styles.Card}>

                <div style={{ ...styles.CardHeader, justifyContent: "space-between", alignItems: "center", display: "flex", flexDirection: "row" }}>
                    <p className="h4" style={styles.text}>Owner Details</p>

                    <div
                        style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
                        onClick={toggleTwo}
                    >
                        <span style={{ fontWeight: "600", fontSize: "14px" }}>Search Landlord Details</span>
                        <i className="now-ui-icons ui-1_zoom-bold" style={{ fontSize: "20px" }} />
                    </div>




                </div>


                <div style={styles.Row}>

                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {

                            saveUserData("ownername", value.target.value);
                        }}
                        type="text"
                        value={state.seller.ownername || ""}
                        label="Owner name"
                    />

                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {

                            saveUserData("company", value.target.value);
                        }}
                        type="text"
                        value={state.seller.company || ""}
                        label="Company Name"
                    />

                </div>


                <div style={styles.Row}>
                    {/* Company Registration Number */}
                    <div style={{ flex: "1", marginRight: "10px" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            onChange={(value) => {
                                saveUserData("registrationNumber", value.target.value);
                            }}
                            type="text"
                            value={state.seller.registrationNumber || ""}
                            label="Company Registration Number"
                        />
                    </div>

                    <div style={{ flex: "0 0 90px", marginRight: "3px" }}>
                        <PhoneInput
                            country={"za"}
                            value={state.seller.countryCode}
                            onChange={(code) => saveUserData("countryCode", `+${code}`)}
                            inputStyle={{
                                width: "100%",
                                height: 55,
                                fontSize: 16,
                                borderRadius: 4,
                                border: `1px solid grey`,
                                backgroundColor: "white",
                                color: "grey",
                            }}
                            dropdownStyle={{ zIndex: 1000 }}
                        />
                    </div>

                    <div style={{ flex: "0 0 200px", marginRight: "10px" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            onChange={(value) => {
                                let phone = value.target.value.replace(/\D/g, "");
                                if (phone.startsWith("0")) phone = phone.substring(1);
                                saveUserData("cellTel", phone);
                            }}
                            type="text"
                            value={state.seller.cellTel || ""}

                            label="Company Cell Number"
                        />
                    </div>

                    <div style={{ flex: "1" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            onChange={(value) => {
                                saveUserData("email", value.target.value);
                            }}
                            type="text"

                            value={state.seller.email || ""}
                            label="Company Email"
                        />
                    </div>
                </div>


            </div>

            <div style={styles.Card}>

                <div style={{ ...styles.CardHeader, justifyContent: "space-between", alignItems: "center", display: "flex", flexDirection: "row" }}>
                    <p className="h4" style={styles.text}>Rates & Levies**</p>




                </div>


                <div style={styles.Row}>

                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {

                            saveUserData("monthlyRates", value.target.value);
                        }}
                        type="text"
                        value={state?.seller?.monthlyRates || ""}
                        label="Monthly Rates(ex VAT)"
                    />

                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {

                            saveUserData("monthlyLevy", value.target.value);
                        }}
                        type="text"
                        value={state.seller?.monthlyLevy || ""}
                        label="Monthly Levy(ex VAT)"
                    />

                </div>


                <div style={styles.Row}>

                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {

                            saveUserData("monthlyLevyPerSQM", value.target.value);
                        }}
                        type="text"
                        value={state.seller?.monthlyLevyPerSQM || ""}
                        label="Monthly Levy Per m²"
                    />

                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {

                            saveUserData("specialLevy", value.target.value);
                        }}
                        type="text"
                        value={state.seller?.specialLevy || ""}
                        label="Special Levy(ex VAT)"
                    />


                </div>

            </div>
            <div style={styles.Card}>
                <div style={styles.CardHeader}>
                    <p className="h4" style={styles.text}>Property Features</p>
                </div>

                <div style={styles.CardBody}>

                    {/* Row 1: Floor Loading & 3-phase Power */}
                    <div style={styles.Row}>


                        <Input
                            variant="outlined"
                            fullWidth
                            type="text"
                            value={state.powerAmps}
                            onChange={(e) => saveData("powerAmps", e.target.value)}
                            label="Power (Amps)"
                        />



                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                height="80%"
                                type="checkbox"
                                checked={state.threePhasePower || false}
                                onChange={(e) => saveData("threePhasePower", e.target.checked)}
                            />
                            <span>3-phase Power</span>
                        </div>
                    </div>


                    {/* Row 2: Truck Access & Yard Access */}
                    <div style={{ ...styles.Row, zIndex: 20, }}>
                        <div style={styles.DropdownWrapper}>
                            <CustomDropDownPicker
                                borderColor="grey"
                                options={truckAccessOptions}
                                value={state.truckAccess}
                                onChange={(value) => saveData("truckAccess", value)}
                                placeholder="Truck Access"

                            />
                        </div>
                        <div style={styles.DropdownWrapper}>
                            <Input

                                variant="outlined"
                                fullWidth
                                type="number"
                                value={state.yardAccess}
                                onChange={(e) => saveData("yardAccess", e.target.value)}
                                label="Yard Access"
                            />
                        </div>
                    </div>






                    {/* Row 4: Height of Eaves & Roller Shutter Doors */}
                    <div style={styles.Row}>

                        <Input
                            variant="outlined"
                            fullWidth
                            type="text"
                            value={state.rollerShutterDoors || ""}
                            onChange={(e) => saveData("rollerShutterDoors", e.target.value)}
                            label="Roller Shutter Doors"
                        />

                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.heightOfRollerShutter || ""}
                            onChange={(e) => saveData("heightOfRollerShutter", e.target.value)}
                            label="Height of Roller Shutter Doors (m)"
                        />

                    </div>


                    {/* Row 5: Height of Roller Shutter Doors & Stud Height */}
                    <div style={styles.Row}>


                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.heightOfEaves || ""}
                            onChange={(e) => saveData("heightOfEaves", e.target.value)}
                            label="Height of Eaves (m)"
                        />


                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.studHeight || ""}
                            onChange={(e) => saveData("studHeight", e.target.value)}
                            label="Stud Height (m)"
                        />
                    </div>

                    {/* Row 6: Height of Roof & Height for Racking */}
                    <div style={styles.Row}>
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.heightOfRoof || ""}
                            onChange={(e) => saveData("heightOfRoof", e.target.value)}
                            label="Height of Roof (m)"
                        />
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.heightForRacking || ""}
                            onChange={(e) => saveData("heightForRacking", e.target.value)}
                            label="Height for Racking (m)"
                        />
                    </div>

                    {/* Row 7: Dock Levellers & Height of Dock Levellers */}
                    <div style={styles.Row}>
                        <Input
                            variant="outlined"
                            fullWidth
                            type="text"
                            value={state.dockLevellers || ""}
                            onChange={(e) => saveData("dockLevellers", e.target.value)}
                            label="Dock Levellers"
                        />
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={state.heightOfDockLevellers || ""}
                            onChange={(e) => saveData("heightOfDockLevellers", e.target.value)}
                            label="Height of Dock Levellers (m)"
                        />
                    </div>
                    {/* Row 3: Power (Amps) & Building Grade */}
                    <div style={{ ...styles.Row, zIndex: 20, }}>


                        <Input
                            variant="outlined"
                            fullWidth
                            type="text"
                            value={state.floorLoading || ""}
                            onChange={(e) => saveData("floorLoading", e.target.value)}
                            label="Floor Loading Capacity (tn/m²)"
                        />


                        <div style={styles.DropdownWrapper}>
                            <CustomDropDownPicker
                                borderColor="grey"
                                options={buildingGrades}
                                value={state.buildingGrade}
                                onChange={(value) => saveData("buildingGrade", value)}
                                placeholder="Building Grade"
                            />
                        </div>
                    </div>
                    {/* Row 8: Security & Air Conditioning */}
                    <div style={styles.Row}>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                type="checkbox"
                                checked={state.security || false}
                                onChange={(e) => saveData("security", e.target.checked)}
                            />
                            <span>Security</span>
                        </div>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                type="checkbox"
                                checked={state.airConditioning || false}
                                onChange={(e) => saveData("airConditioning", e.target.checked)}
                            />
                            <span>Air Conditioning</span>
                        </div>
                    </div>

                </div>
            </div>



            {/* <div style={styles.Card}>
                <div style={styles.CardHeader}>
                    <p className="h4" style={styles.text}>Property Improvements</p>
                </div>

                <div style={styles.CardBody}>

               
                    <div style={styles.Row}>


                        <Input
                            variant="outlined"
                            fullWidth
                            type="text"
                            value={state.kitchens}
                            onChange={(e) => saveData("kitchens", e.target.value)}
                            label="Kitchens (amount)"
                        />
                    </div>


               
                    <div style={{ ...styles.Row, zIndex: 20, }}>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                height="80%"
                                type="checkbox"
                                checked={state.dishwasher || false}
                                onChange={(e) => saveData("dishwasher", e.target.checked)}
                            />
                            <span>Dishwasher</span>
                        </div>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                height="80%"
                                type="checkbox"
                                checked={state.sink || false}
                                onChange={(e) => saveData("sink", e.target.checked)}
                            />
                            <span>Sink</span>
                        </div>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                height="80%"
                                type="checkbox"
                                checked={state.cleaningService || false}
                                onChange={(e) => saveData("cleaningService", e.target.checked)}
                            />
                            <span>Cleaning Service</span>
                        </div>
                    </div>


                    <div style={styles.Row}>
                        <Input
                            multiline
                            variant="outlined"
                            rows={4}
                            fullWidth
                            value={state.kitchenDescription || ""}
                            onChange={(value) => {
                                value.preventDefault();
                                saveData("kitchenDescription", value.target.value);
                            }}
                            type="text"

                            label="Kitchen Description"
                        />
                    </div>


           
                    <div style={styles.Row}>


                        <Input
                            variant="outlined"
                            fullWidth
                            type="text"
                            value={state.bathrooms}
                            onChange={(e) => saveData("bathrooms", e.target.value)}
                            label="Bathrooms (amount)"
                        />
                    </div>


               
                    <div style={{ ...styles.Row, zIndex: 20, }}>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                height="80%"
                                type="checkbox"
                                checked={state.communalBathrooms || false}
                                onChange={(e) => saveData("communalBathrooms", e.target.checked)}
                            />
                            <span>Communal Bathrooms</span>
                        </div>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                height="80%"
                                type="checkbox"
                                checked={state.unisexBathrooms || false}
                                onChange={(e) => saveData("unisexBathrooms", e.target.checked)}
                            />
                            <span>Unisex Bathrooms</span>
                        </div>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                height="80%"
                                type="checkbox"
                                checked={state.executiveBathrooms || false}
                                onChange={(e) => saveData("executiveBathrooms", e.target.checked)}
                            />
                            <span>Executive Bathrooms</span>
                        </div>
                    </div>


                    <div style={styles.Row}>
                        <Input
                            multiline
                            variant="outlined"
                            rows={4}
                            fullWidth
                            value={state.bathroomDescription || ""}
                            onChange={(value) => {
                                value.preventDefault();
                                saveData("bathroomDescription", value.target.value);
                            }}
                            type="text"

                            label="Bathroom Description"
                        />
                    </div>


              


              
             
                

                </div>
            </div> */}


            <div style={styles.Card}>
                {/* Card Header */}
                <div style={{ ...styles.CardHeader, justifyContent: "space-between", alignItems: "center", display: "flex", flexDirection: "row" }}>
                    <p className="h4" style={styles.text}>Lease Details</p>
                    <button
                        style={styles.MinimizeBtn}
                        onClick={() => setCollapsed(!collapsed)}
                    >
                        {collapsed ? "+" : "—"}
                    </button>
                </div>

                {/* Card Body */}
                <div style={styles.CardBody}>

                    {/* Row 1: Multi Tenanted & Lease Type */}
                    <div style={{ ...styles.Row, zIndex: 201, }}>
                        <div style={styles.CheckboxWrapper}>
                            <Checkbox
                                type="checkbox"
                                checked={state.multiTenanted || false}
                                onChange={(e) => saveData("multiTenanted", e.target.checked)}
                            />
                            <span>Multi Tenanted</span>
                        </div>

                        <div style={{
                            position: 'relative',
                            width: '100%',
                            zIndex: 2000,
                            background: 'white',
                        }}
                        >
                            <CustomDropDownPicker
                                options={leaseTypes}
                                value={state.leaseType}
                                onChange={(value) => saveData("leaseType", value)}
                                placeholder="Lease Type"
                                borderColor="grey"
                            />
                        </div>
                    </div>

                    {/* Row 2: Lease Period & Deposit */}
                    <div style={{ ...styles.Row, zIndex: 200 }}>
                        <div style={styles.DropdownWrapper}>
                            <CustomDropDownPicker
                                options={leasePeriods}
                                value={state.leasePeriod || ""}
                                onChange={(value) => saveData("leasePeriod", value)}
                                placeholder="Lease Period"
                                fullWidth
                                borderColor="grey"
                            />
                        </div>
                    </div>

                    {/* Row 3: Available From */}

                    <div style={styles.Row}>
                        <div style={{ width: "100%" }}>
                            <CustomDropDownPicker
                                borderColor="grey"
                                options={availabilityTypes}
                                isMulti={false}
                                onChange={(e) => {
                                    const today = moment().format("YYYY-MM-DD");
                                    if (e === 'Immediate') {
                                        setstate({
                                            ...state,
                                            availableFrom: today,
                                            availabilityOption: e,
                                        })
                                    }
                                    if (e === 'Negotiable') {
                                        setstate({
                                            ...state,
                                            availableFrom: "To Be Decided",
                                            availabilityOption: e,
                                        })
                                    }
                                    if (e === 'Specific Date') {
                                        setstate({
                                            ...state,
                                            availableFrom: null,
                                            availabilityOption: e,
                                        })
                                    }
                                }}
                                value={state.availabilityOption || null}
                                placeholder="Select Availability Option"
                            />
                        </div>
                        <Input
                            fullWidth
                            disabled={state.availabilityOption !== "Specific Date"}
                            type="date"
                            style={styles.inputStyle}
                            value={
                                state.availableFrom && state.availableFrom !== "To Be Decided"
                                    ? state.availableFrom
                                    : ""
                            }
                            placeholder="Available From"
                            onChange={(e) => { saveData("availableFrom", e.target.value) }}
                        />
                    </div>



                </div>
            </div>
            <div style={styles.Card}>
                {/* Card Header */}
                <div style={{ ...styles.CardHeader, justifyContent: "space-between", alignItems: "center", display: "flex", flexDirection: "row" }}>
                    <p className="h4" style={styles.text}> Mandate Details</p>
                    <button
                        style={styles.MinimizeBtn}
                        onClick={() => setCollapsed(!collapsed)}
                    >
                        {collapsed ? "+" : "—"}
                    </button>
                </div>

                {/* Card Body */}
                <div style={styles.CardBody}>

                    {/* Row 1: Multi Tenanted & Lease Type */}
                    <div style={{ ...styles.Row, zIndex: 20, }}>
                        <div style={styles.DropdownWrapper}>
                            <CustomDropDownPicker
                                borderColor="grey"
                                value={state.typeOfMandate || ""}
                                options={mandateTypes}
                                isMulti={false}
                                onChange={(e) => saveData("typeOfMandate", e)}
                                placeholder="Select A Mandate Type**"
                            />
                        </div>

                        <Input
                            fullWidth
                            type="date"
                            style={styles.inputStyle}
                            value={onMarketSince || ""}
                            label="On Market Since"
                            onChange={(e) => setOnMarketSince(e.target.value)}
                        />
                    </div>

                    {/* Row 2: Lease Period & Deposit */}
                    <div style={styles.Row}>
                        <Input
                            fullWidth
                            type="date"
                            style={styles.inputStyle}
                            value={mandateStartDate || ""}
                            label="Mandate Start Date"
                            onChange={(e) => setMandateStartDate(e.target.value)}
                        />






                        <Input
                            fullWidth
                            type="date"
                            style={styles.inputStyle}
                            value={mandateEndDate || ""}
                            label="Mandate End Date"
                            onChange={(e) => setMandateEndDate(e.target.value)}
                        />
                    </div>

                    {/* Row 3: Available From */}
                    <div style={styles.Row}>
                        <div style={styles.DropdownWrapper}>
                            {/* / */}
                        </div>
                        {/* empty right column for alignment */}
                        <div></div>
                    </div>

                </div>
            </div>



            <div style={styles.Card}>
                {/* Card Header */}
                <div
                    style={{
                        ...styles.CardHeader,
                        justifyContent: "space-between",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "row",
                    }}
                >
                    <p className="h4" style={styles.text}>Parking</p>
                </div>

                {/* Open Parking */}
                <div style={{ marginBottom: "24px", paddingBottom: "16px", borderBottom: "1px solid #e0e0e0" }}>
                    <p className="h4" style={{ ...styles.text, marginBottom: "12px" }}>Open Parking</p>

                    <div style={{ display: "flex", gap: "16px", marginBottom: "12px" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Bays"
                            onChange={(e) => saveData("openParkingBays", e.target.value)}
                        />
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Cost / Bay (Ex VAT)"
                            onChange={(e) => saveData("openParkingCostPerBay", e.target.value)}
                        />
                    </div>

                    <Input
                        variant="outlined"
                        fullWidth
                        type="number"
                        label="Total Cost (Ex VAT)"
                        onChange={(e) => saveData("openParkingTotalCost", e.target.value)}
                    />
                </div>

                {/* Covered Parking */}
                <div style={{ marginBottom: "24px", paddingBottom: "16px", borderBottom: "1px solid #e0e0e0" }}>
                    <p className="h4" style={{ ...styles.text, marginBottom: "12px" }}>Covered Parking</p>

                    <div style={{ display: "flex", gap: "16px", marginBottom: "12px" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Bays"
                            onChange={(e) => saveData("coveredParkingBays", e.target.value)}
                        />
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Cost / Bay (Ex VAT)"
                            onChange={(e) => saveData("coveredParkingCostPerBay", e.target.value)}
                        />
                    </div>

                    <Input
                        variant="outlined"
                        fullWidth
                        type="number"
                        label="Total Cost (Ex VAT)"
                        onChange={(e) => saveData("coveredParkingTotalCost", e.target.value)}
                    />
                </div>

                {/* Basement Parking */}
                <div>
                    <p className="h4" style={{ ...styles.text, marginBottom: "12px" }}>Basement Parking</p>

                    <div style={{ display: "flex", gap: "16px", marginBottom: "12px" }}>
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Bays"
                            onChange={(e) => saveData("basementParkingBays", e.target.value)}
                        />
                        <Input
                            variant="outlined"
                            fullWidth
                            type="number"
                            label="Cost / Bay (Ex VAT)"
                            onChange={(e) => saveData("basementParkingCostPerBay", e.target.value)}
                        />
                    </div>

                    <Input
                        variant="outlined"
                        fullWidth
                        type="number"
                        label="Total Cost (Ex VAT)"
                        onChange={(e) => saveData("basementParkingTotalCost", e.target.value)}
                    />
                </div>
            </div>






            <div style={styles.Card}>
                <div style={styles.CardHeader}>
                    <p className="h4" style={styles.text}>Dimensions Details</p>
                </div>





                <div style={styles.Row}>
                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            if (value.target.value.includes(",")) {
                                alert(`GLA requires a "." for decimal numbers. Please replace "," with a "."`)
                                return;
                            }
                            saveData("gla", value.target.value);
                        }}
                        type="text"
                        required
                        label="Total Size of Property (Gross Lettable Area)                                m²"
                    />
                </div>


                <div style={styles.Row}>


                    <Input
                        variant="outlined"
                        fullWidth
                        type="text"
                        label="Land Size                            m²**"
                        value={state.landSize}
                        onChange={(e) => saveData("landSize", e.target.value)}
                    />

                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("floorSize", value.target.value);
                        }}
                        type="text"
                        value={state.floorSize}
                        label="Floor Size                               m²"
                    />



                </div>


                <div style={styles.Row}>



                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("officeSize", value.target.value);
                        }}
                        type="text"

                        label="Office Size                               m²"
                    />
                </div>


                <div style={styles.Row}>
                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("retailSize", value.target.value);
                        }}
                        type="text"

                        label="Retail Size                               m²"
                    />

                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("factorySize", value.target.value);
                        }}
                        type="text"

                        label="Factory Size                               m²"
                    />

                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("yardSize", value.target.value);
                        }}
                        type="text"

                        label="Yard Size                               m²"
                    />

                </div>


                <div style={styles.Row}>
                    <Input

                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("buildingHieght", value.target.value);
                        }}
                        type="text"
                        label="Building Height                               m²"
                    />
                </div>

            </div>

            {/* Error handling for AI marketing reducer */}
            {aiMarketingReducer.error && aiMarketingReducer.error.flag && (
                <div style={{ color: 'red', marginBottom: 10 }}>
                    {aiMarketingReducer.error.msg || "An error occurred while generating the description."}
                </div>
            )}

            <div style={styles.Card}>

                <div style={{
                    ...styles.CardHeader, display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between"
                }}>
                    <p className="h4" style={styles.text}>Marketing Details</p>




                    <div style={styles.Row}>
                        {/* New: Generate AI Description */}
                        <Button
                            style={{
                                backgroundColor: STYLES.PRIMARY_APP_CLR,
                                color: "white",
                                width: "fit-content",
                                height: 44,
                                borderRadius: 8,
                                fontSize: 16,
                                fontWeight: "bold",
                                marginTop: 12,
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                padding: "0 20px",
                                cursor: "pointer"
                            }}
                            variant="contained"
                            color="success"
                            onClick={handleGenerateDescription}
                            disabled={aiMarketingReducer.loadingDescription}
                        >
                            <i className="now-ui-icons tech_laptop" style={{ fontSize: 22, marginRight: 8 }} />
                            {aiMarketingReducer.loadingDescription ? (
                                // Cool loading animation (CSS spinner)
                                <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span
                                        style={{
                                            display: "inline-block",
                                            width: 22,
                                            height: 22,
                                            border: "3px solid #fff",
                                            borderTop: `3px solid ${STYLES.PRIMARY_APP_CLR}`,
                                            borderRadius: "50%",
                                            animation: "spin 1s linear infinite",
                                            marginRight: 8
                                        }}
                                    />
                                    Generating...
                                    <style>
                                        {`
                                        @keyframes spin {
                                            0% { transform: rotate(0deg);}
                                            100% { transform: rotate(360deg);}
                                        }
                                        `}
                                    </style>
                                </span>
                            ) : (
                                "Generate with AI"
                            )}
                        </Button>
                    </div>
                </div>


                <p className="h6" style={styles.text}>Give the AI text a quick proofread. Double-check for typos or odd phrasing before creating.</p>


                <div style={styles.Row}>
                    <Input

                        variant="outlined"
                        fullWidth
                        value={state.marketingHeading || ""}
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("marketingHeading", value.target.value);
                        }}
                        type="text"
                        required
                        label="Marketing Heading"
                    />
                </div>

                <div style={styles.Row}>
                    <Input
                        multiline
                        variant="outlined"
                        rows={4}
                        fullWidth
                        value={state.description || ""}
                        sx={{
                            '& textarea': {
                                resize: 'vertical',        // 'vertical' | 'horizontal' | 'both'
                                overflow: 'auto',
                            },
                        }}
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("description", value.target.value);
                        }}
                        type="text"
                        required
                        label="Marketing Description"
                    />
                </div>

            </div>

            <div style={styles.Card}>

                <div style={styles.CardHeader}>
                    <p className="h4" style={styles.text}>Media Details</p>
                </div>
                <div style={{ ...styles.Row, justifyContent: 'center', alignItems: 'center' }}>

                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        {/* Hidden file input */}
                        <RSInput
                            innerRef={fileInputRef}
                            onChange={
                                onImageChange}
                            type="file"
                            multiple
                            accept="image/*"
                            style={{ display: "none" }} // hide the default input
                        />

                        {/* Styled button to trigger input */}
                        <Button color="primary" style={{
                            backgroundColor: STYLES.PRIMARY_APP_CLR,
                            color: "white",
                            width: "fit-content",
                            height: 44,
                            borderRadius: 8,
                            fontSize: 16,
                            fontWeight: "bold",
                            marginTop: 12,
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            padding: "0 20px",
                            cursor: "pointer"
                        }} onClick={handleButtonClick}>
                            Upload Images
                        </Button>
                    </div>
                </div>

                <div style={{ marginBottom: 50 }}><CustomImageDragger data={image} setValue={setImage} captionsData={captions} setCaptionsData={setCaptions} /></div>

                <div style={{ ...styles.Row, justifyContent: 'center', alignItems: 'center' }}>

                    <Input
                        variant="outlined"
                        fullWidth
                        onChange={(value) => {
                            value.preventDefault();
                            saveData("youtubeLinkId", value.target.value);
                        }}
                        type="text"
                        label="Youtube Video ID"
                    />
                </div>

            </div>


            <div style={styles.Card}>

                <Button

                    style={{ backgroundColor: STYLES.PRIMARY_APP_CLR, color: "white", width: "100%", height: 50, borderRadius: 10, fontSize: 20, fontWeight: "bold", marginTop: 20 }}

                    onClick={async () => {


                        if (state.ownerBroker) {


                            let ListingData = {
                                ...state,
                                ImageCaptions: mapImagesToCaptions(image, captions),
                                agencyId: Number(currentBranch.agencyId),
                                BranchPPId: currentBranch?.BranchPPId ? currentBranch.BranchPPId : null,
                                onMarketSince: onMarketSince,
                                mandateStartDate: mandateStartDate,
                                mandateEndDate: mandateEndDate,
                                seller: {
                                    ...state.seller,
                                    phoneNumber: state.seller.countryCode && state.seller.cellTel ? `${state.seller.countryCode}${state.seller.cellTel}` : "",
                                },
                                userdetials: {
                                    ...state.userdetials,
                                    agentId: auth.info.profile.agentId,
                                },
                                address: {
                                    coords: state.address.coords
                                        ? state.address.coords
                                        : {
                                            lat: 0.0,
                                            lng: 0.0,
                                        },
                                    description: state.address.description
                                        ? state.address.description
                                        : " ",
                                    suburb: state?.address?.suburb
                                        ? state.address.suburb
                                        : " ",
                                    address: state?.address?.description
                                        ? state?.address?.description
                                        : " ",
                                    streetNumber: state?.address?.streetNumber
                                        ? state?.address?.streetNumber
                                        : " ",
                                    streetName: state?.address?.streetName
                                        ? state?.address?.streetName
                                        : " ",
                                    unitNumber: state?.address?.unitNumber
                                        ? state?.address?.unitNumber
                                        : " ",
                                    complexName: state?.address?.complexName
                                        ? state?.address?.complexName
                                        : " ",
                                    floorNumber: state?.address?.floorNumber
                                        ? state?.address?.floorNumber
                                        : " ",
                                    buildingName: state?.address?.buildingName
                                        ? state?.address?.buildingName
                                        : " ",
                                },
                            };

                            if (state.gla) {
                                // Check if images are provided
                                if (!image || image.length === 0) {
                                    alert(
                                        "Please upload at least one image before creating the listing."
                                    );
                                } else {
                                    if (ListingData.address.description) {


                                        if (ListingData.locationType) {



                                            if (ListingData.selectedArea) {

                                                dispatch(CreateListing(ListingData, image))
                                            } else {
                                                alert("Please Provide a Location");
                                            }

                                        } else {
                                            alert("Please Provide a location Type");
                                        }

                                    } else {
                                        alert("Address is a required field.");
                                    }
                                }
                            } else {
                                alert("Gross lettable area is a required field.");
                            }
                        } else {
                            alert("Please select a Broker");
                        }
                    }
                    }
                >
                    Create Listing
                </Button>

            </div>

            <RenderModal />

        </div>
    );
}

export default CreateListing;
